import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock reports — shown on the reports & payouts stage. */
const ReportsScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/Reports.PNG" alt="CleanDock reports" />
)

export default ReportsScreen
